export default function Tick({ color = "#00BF86", size = 24 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 36" width={size} height={size}>
      <path
        d="M17.925 25.233L42.225.935l5.399 5.4-29.699 29.698-1.35-1.35-16.199-16.2 5.4-5.399 12.15 12.15z"
        fillRule="evenodd"
        fill={color}
      />
    </svg>
  );
}
